import { render, staticRenderFns } from "./white-prescribe-modal.vue?vue&type=template&id=051a1bc3&scoped=true"
import script from "./white-prescribe-modal.vue?vue&type=script&lang=js"
export * from "./white-prescribe-modal.vue?vue&type=script&lang=js"
import style0 from "./white-prescribe-modal.vue?vue&type=style&index=0&id=051a1bc3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a1bc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051a1bc3')) {
      api.createRecord('051a1bc3', component.options)
    } else {
      api.reload('051a1bc3', component.options)
    }
    module.hot.accept("./white-prescribe-modal.vue?vue&type=template&id=051a1bc3&scoped=true", function () {
      api.rerender('051a1bc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/white-prescribe-modal/white-prescribe-modal.vue"
export default component.exports